import { useState } from 'react'
import { generateModuleSchema } from '../Report'
import { ReportOffcanvas } from './ReportOffcanvas'
import { IconCalendar } from '@tabler/icons-react'

export const CustomReport = ({
    filterName,
    setTableData,
    setSelectedModule,
    setTableTitle,
    tableRef,
}) => {
    const [showReportCanvas, setShowReportCanvas] = useState(false)
    const schemaFields = generateModuleSchema(filterName.split(" ").join("_"))

    return (
        <>
            <div className="report-card">
                <div className="card-content" onClick={() => setShowReportCanvas(true)}>
                    <div className="card-icon">
                        <IconCalendar stroke={1} />
                    </div>
                    <div className="card-text">
                        <h3 className="card-title">Custom Report</h3>
                        <p className="card-description">Create Your Customize Report.</p>
                    </div>
                </div>
            </div>
            {showReportCanvas && (
                <ReportOffcanvas
                    show={showReportCanvas}
                    onHide={() => setShowReportCanvas(false)}
                    module_name={filterName.split(" ").join("_")}
                    schemaFields={schemaFields || []}
                    duration={null}
                    setTableTitle={setTableTitle}
                    setTableData={setTableData}
                    setSelectedModule={setSelectedModule}
                    tableRef={tableRef}
                />
            )}
        </>
    )
}


